import style from "../style/worldcupbar.module.css";
export default function WorldCupBar({ round, currendRound, gameProgress }) {
  const matchNumber = () => {
    if (gameProgress.game16.length === 16 && gameProgress.game8.length < 8)
      return 8;
    if (gameProgress.game8.length === 8 && gameProgress.game4.length < 4)
      return 4;
    if (gameProgress.game4.length === 4 && gameProgress.game2.length < 2)
      return 2;
  };

  return (
    <div>
      <p className={style.WorldCupBar_round}>
        {gameProgress.game2.length !== 2 && `${currendRound}/`}
        {matchNumber()}
      </p>
    </div>
  );
}
